import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { I18nProvider } from '@fiverr-private/i18n-react';
import { Placeholder } from './placeholder';
import './styles.scss';

const NoReviews = ({ type, selfView, isBuyerProfile, userName }) => (
    <div className={classNames('no-reviews', { 'buyer-profile': isBuyerProfile })}>
        {isBuyerProfile && <Placeholder />}
        <p className={classNames('no-reviews-text', { 'buyer-profile': isBuyerProfile })}>
            <I18nProvider>
                {({ i18n }) => {
                    const typeString = type
                        ? i18n.t(`reviews.gigs._inner_gig.drop_${type}`)
                        : i18n.t('reviews.general.reviews');

                    if (selfView) {
                        return i18n.t('reviews.users.user_show.reviews_not_found_self_view');
                    } else if (isBuyerProfile) {
                        return i18n.t('reviews.users.user_show.reviews_not_found_with_name', { buyerName: userName });
                    } else {
                        return i18n.t('reviews.users.user_show.reviews_not_found', { type: typeString.toLowerCase() });
                    }
                }}
            </I18nProvider>
        </p>
    </div>
);

NoReviews.propTypes = {
    type: PropTypes.string,
    userName: PropTypes.string,
    selfView: PropTypes.bool,
    isBuyerProfile: PropTypes.bool,
};

NoReviews.defaultProps = {
    selfView: false,
    isBuyerProfile: false,
};

export default NoReviews;
